import { parseISO } from "date-fns";

// Semantic date-fns format constants for the most common display formats.
// Data-interchange formats (yyyy-MM-dd in publish logs / API params) stay
// inline where they belong.

/** e.g. "07 Aug" — compact list cells. */
export const DATE_SHORT = "dd MMM";

/** e.g. "07 Aug 2026" — list meta / timelines. */
export const DATE_FULL = "dd MMM yyyy";

/** e.g. "07 Aug 2026, 14:30" — precise timestamps. */
export const DATE_TIME = "dd MMM yyyy, HH:mm";

/**
 * Picked day + the current time of day, as ISO. Same-day release records keep
 * the order they were recorded in (date-only values all land on 00:00 and tie).
 * Accepts a Date or a "yyyy-MM-dd" string (read as a local day).
 */
export const withCurrentTime = (day: Date | string) => {
  const now = new Date();
  const at = typeof day === "string" ? parseISO(day) : new Date(day);
  at.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds(),
  );
  return at.toISOString();
};
